<!-- Table Loader -->
<div class="pmd-circle-loader"
    aria-label="Data is loading...">
    <svg class="circular"
        viewBox="25 25 50 50"
        aria-hidden="true">
        <circle class="path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="2"
            stroke-miterlimit="10"
            aria-hidden="true" />
    </svg>
</div>
<!-- End Table Loader -->